/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @author Alexander Golshtein
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.23.0
 */

import { ECustomNumberConflictCodes } from '@/main/components/Table/helpers/getActionConflictsParsed';

import { EActionConflictTypes, IActionConflictItem } from '../../WizardProductOfferings/wizardProductOfferingsTypes';

export const isCollectiveProductCustomConflict = (actionConflict: IActionConflictItem) => {
    if (
        actionConflict.type === EActionConflictTypes.ERROR &&
        (actionConflict.code === ECustomNumberConflictCodes.TARIFF_WITH_GROUP ||
            actionConflict.code === ECustomNumberConflictCodes.SUBSCRIBER_ALREADY_IN_GROUP)
    )
        return true;

    return false;
};
